// extracted by mini-css-extract-plugin
export default {"parent":"tooltip_parent__d-HiA","tooltip":"tooltip_tooltip__TcPT7","arrow":"tooltip_arrow__idwFS"};